export default __webpack_public_path__ + "static/media/Ellipse orange (Stroke).af99f157.svg";